import { motion } from 'framer-motion';
import React, { useEffect } from 'react';
import YoutubeEmbed from '../../components/YoutubeEmbed';
import { useApp } from '../../context/AppContext';
import { slideUp } from '../../util/animation';


export default function About() {

	const {goToTop} = useApp()
	useEffect(() => {
    goToTop()
  }, [goToTop])

  return (
    <motion.div className="container" variants={slideUp} initial="hidden" animate="show">
    <section  className="section-space section-gray-bg about position-relative mt-2">
      <div className="container">
        <div className="row rowsafari">
          <div className="col-lg-6 res-desk-mar-bot">
            <h6 className="section-grp-margin-bottom theme-color-1">About Us</h6>
            <h3 className="section-margin-bottom">
              IPC Global<br /> Experienced IT Services<br /></h3>
            <p>
              IPC Global leverage best-of-breed technologies to deliver data, analytic, and cloud solutions that turn your organizations data into value.
            </p>
            <div className="btn-wrapper">	
              <a href="https://www.ipc-global.com/about-ipc" rel="noreferrer" target="_blank" className="boxed-btn-1">About us...</a>
            </div>
          </div>
          <div className="col-lg-6">
						<YoutubeEmbed embedId="AeligMfjqsc" />
          </div>
        </div>
      </div>
    </section>
    <section className="section-space section-white-bg">
		<div className="container">
			<div className="section-width">
				<h6 className="theme-color-1 section-grp-margin-bottom">Technologies</h6>
				<h2>Technologies to deliver data</h2>
			</div>
			<div className="row rowsafari">
				<div className="col-lg-3 col-md-6 col-sm-6 res-desk-mar-bot">
					<div className="team-box content-width text-center pt-3" style={{height: '400px'}}>
						<img src="https://static.wixstatic.com/media/592604_a471f69ccd9e492f8c44200bfd7b5072~mv2.png/v1/fill/w_67,h_67,al_c,usm_0.66_1.00_0.01,enc_auto/qlik-logo-blue-40-trans.png" alt="Qlik icon" className="img-fluid" />
						<div className="team-content">
							<h5 className="section-grp-margin-bottom" style={{height: '80px'}}>Qlik Analytics Platform</h5>
							<p className="lt-space">Qlik enables end-to-end data integration and analytics. It brings all your data together in one place and empowers everyone in your organization to make better decisions daily.</p>
						</div>
					</div>
				</div>
				<div className="col-lg-3 col-md-6 col-sm-6 res-desk-mar-bot">
					<div className="team-box content-width text-center pt-3" style={{height: '400px'}}>
						<img src="https://static.wixstatic.com/media/592604_d5a8975a5a8e4f84a288eddd00e13ae3~mv2.png/v1/fill/w_67,h_67,al_c,usm_0.66_1.00_0.01,enc_auto/aws-logo-blue-40-trans.png" alt="aws logo" className="img-fluid" />
						<div className="team-content">
							<h5 className="section-grp-margin-bottom" style={{height: '80px'}}>Amazon Web Services (AWS)</h5>
							<p className="lt-space">Amazon Web Services is the world’s most comprehensive and broadly adopted cloud platform. The AWS cloud drives lower costs and increased agility for organizations.</p>
						</div>
					</div>
				</div>
				<div className="col-lg-3 col-md-6 col-sm-6 res-mob-mar-bot">
					<div className="team-box content-width text-center pt-3" style={{height: '400px'}}>
						<img src="https://static.wixstatic.com/media/592604_b12d550c8b99456db1e0045354ae584f~mv2.png/v1/fill/w_67,h_67,al_c,usm_0.66_1.00_0.01,enc_auto/datarobot-logo-blue-40-trans.png" alt="robo datarobot" className="img-fluid" />
						<div className="team-content ">
							<h5 className="section-grp-margin-bottom" style={{height: '80px'}}>DataRobot Enterprise AI</h5>
							<p className="lt-space">Advanced enterprise AI platform that enables building, deploying, and maintaining artificial intelligence and machine learning at scale.</p>
						</div>
					</div>
				</div>
				<div className="col-lg-3 col-md-6 col-sm-6">
					<div className="team-box content-width text-center pt-3" style={{height: '400px'}} >
						<img src="https://static.wixstatic.com/media/592604_b21f80cebfae439ca5324403480fe074~mv2.png/v1/fill/w_67,h_67,al_c,usm_0.66_1.00_0.01,enc_auto/vizlib-logo-blue-40-trans.png" alt="vizlib logo" className="img-fluid" />
						<div className="team-content">
							<h5 className="section-grp-margin-bottom" style={{height: '80px'}}>Vizlib</h5>
							<p className="lt-space">					
Vizlib
Push native Qlik Sense reporting further with Vizlib. Unlock robust data insights with customizable dashboards, slice and dice data the way you want to, and utilize powerful writeback capabilities.
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
  </motion.div>
  )
}